var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert-box",class:{ success : _vm.type == 'success', 'success-2' : _vm.type == 'success-2', error : _vm.type == 'error', warning : _vm.type == 'warning' }},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }